/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

/**
 * Account type
 */
export type CardTransactionResponseAccountType = typeof CardTransactionResponseAccountType[keyof typeof CardTransactionResponseAccountType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CardTransactionResponseAccountType = {
  CREDIT: 'CREDIT',
  DEBIT: 'DEBIT',
} as const;
